import { Component, OnInit } from "@angular/core";
import { NavController } from "@ionic/angular";
import { BackNativeService } from "../../../shared/service/comunicator-native/back-native/back-native";
import { FormBuilder, FormControl } from "@angular/forms";
import { FormValidations } from "../../../shared/form-validation/form-validation";
import { Title } from "@angular/platform-browser";
import { DefaultPageComponent } from "../../../shared/page/default-page.component";
import { JourneyService } from "../../../shared/service/journey/journey.service";
import { ReturnNativeService } from "../../../shared/service/comunicator-native/return-native/return-native";
import { AnalycticsNativeService } from "../../../shared/service/comunicator-native/analytics-native/analyctics-native";
import {
  Keyboard,
  KeyboardResizeMode,
} from "@awesome-cordova-plugins/keyboard/ngx";
import { CheckboxModel } from "../../../shared/model/checkbox.model";
import { CpfModel } from "../../../shared/service/cpf/model/cpf.model";
import { MaritalStatusService } from "../../service/marital-status.service";
import { DataOrigin } from "../../../shared/model/DataOrigin";
import { CpfFactoryService } from "../../../shared/service/cpf/cpf-factory-service";
import { TrackTypes } from "../../../shared/service/journey/tracks/model/track-types";
import { AnalyticsPageModel } from "../../../shared/model/analyticsPage";
import { AnalyticsPageService } from "../../../shared/service/analytics/analytics-page.service";
import { AnalyticsGA4PageService } from "../../../shared/service/analytics-ga4-pages/analytics-ga4-page.service";
import { AnalyticsGA4PagesModel } from "../../../shared/service/analytics-ga4-pages/analytics-ga4-pages-models";
@Component({
  selector: "app-spouse",
  templateUrl: "./spouse.component.html",
  styleUrls: ["./spouse.component.scss"],
})
export class SpouseComponent extends DefaultPageComponent implements OnInit {
  public name = "";
  public cpf = "";
  cpfSucess = false;
  public idComponentName = "spouseName";
  public idComponentCpf = "spouseCpf";
  placeholder = "Qual o nome?";
  placeholderCpf = "Qual o CPF?";
  error = false;
  errorCpf = false;
  buttonEnable = false;
  textError = "";
  textErrorCpf = "";
  minLengthErrorText = "Esse nome está incompleto";
  minLengthErrorCpfText = "Esse CPF está incompleto";
  invalidErrorText = "Nome inválido";
  invalidErrorCpfText = "CPF inválido";
  invalidErrorIrrCpfText = "CPF irregular";
  maxLengthErrorText =
    "Limite de caracteres alcançado, você pode abreviar os nomes do meio";
  idLabel = "nameSpouseLabel";
  idLabelCpf = "cpfSpouseLabel";
  label = "Qual o nome?";
  labelCpf = "Qual o CPF?";
  startStage = "";
  endStage = "";
  cpfData: CpfModel;
  selectCheckbox: CheckboxModel[] = [];
  checkboxList: CheckboxModel[] = [
    new CheckboxModel(
      "no-cpf",
      "Cônjuge estrangeiro sem CPF",
      "Cônjuge estrangeiro sem CPF",
      false
    ),
  ];
  labelButton = "Continuar";
  loading = false;
  spouse = "";
  dataOrigin = DataOrigin.Mobile;
  idLabelSpouse = "spouseLabel";
  idCheckboxSpouse = "spouseCheckbox";
  idButtonSpouse = "spouseButton";

  spouseForm = this.formBuilder.group({
    nameSpouse: this.formBuilder.control("", [
      FormValidations.checkShortName,
      FormValidations.validationsName,
    ]),
    cpfSpouse: this.formBuilder.control(""),
  });
  headerId = "spouse";
  titlePage = "Estado civil";
  analyticsPage: AnalyticsPageModel;
  analyticsPageGA4: AnalyticsGA4PagesModel;

  constructor(
    public router: NavController,
    public backNativeService: BackNativeService,
    public journeyService: JourneyService,
    private formBuilder: FormBuilder,
    private title: Title,
    public returnNativeService: ReturnNativeService,
    public analycticsNativeService: AnalycticsNativeService,
    private keyBoard: Keyboard,
    private cpfFactoryService: CpfFactoryService,
    public maritalStatusService: MaritalStatusService,
    private analyticsPageService: AnalyticsPageService,
    private analyticsGA4PageService: AnalyticsGA4PageService
  ) {
    super(backNativeService, journeyService, router, returnNativeService);

    const dataOriginTrack = this.journeyService.getCurrentTrack(this.headerId)
      ?.parameters?.dataOrigin;

    this.dataOrigin = dataOriginTrack ? dataOriginTrack : this.dataOrigin;
    this.getAnalyticsPage();
    this.getAnalyticsPageGA4();
    this.getTrack();
    this.keyBoard.setResizeMode(KeyboardResizeMode.Body);
  }

  /* istanbul ignore next */
  get nameSpouse() {
    return this.spouseForm.get("nameSpouse");
  }
  get cpfSpouse() {
    return this.spouseForm.get("cpfSpouse");
  }

  /* istanbul ignore next */
  ngOnInit() {
    this.setTitle();
    this.headerFocus();
    this.spouseText(false);
    this.editFieldInvest("conjuge_nome", "spouseName", "maritalStatus");
  }

  getAnalyticsPage() {
    this.analyticsPage = this.analyticsPageService.setAnalyticsPage();
  }

  spouseText(value: boolean) {
    if (
      this.journeyService.registratioJourney.data.maritalStatus
        .maritalStatus === "608"
    ) {
      this.spouse = "cônjuge";
      this.checkboxList = [
        new CheckboxModel(
          "no-cpf",
          "Cônjuge estrangeiro sem CPF",
          "Cônjuge estrangeiro sem CPF",
          value
        ),
      ];
    } else {
      this.spouse = "companheiro";
      this.checkboxList = [
        new CheckboxModel(
          "no-cpf",
          "Companheiro estrangeiro sem CPF",
          "Companheiro estrangeiro sem CPF",
          value
        ),
      ];
    }
    this.selectCheckbox = this.checkboxList;
  }

  getTrack() {
    const track = this.journeyService.selectedTrack;
    const path = "marital-status";

    if (
      this.journeyService.journey === TrackTypes.CONTA_ION ||
      this.journeyService.journey === TrackTypes.CONTA_ION_MARITAL
    ) {
      this.startStage = "2";
      this.endStage = "2";
    } else {
      this.startStage = track.getIndexPage(this.headerId, path).toString();
      this.endStage = track.getTotalPage(path).toString();
    }
  }

  analyticsData() {
    const it_pagename = this.analyticsPage.spouse;
    this.analycticsNativeService.analyticsTrackStateCommunicator(it_pagename);
  }

  getAnalyticsPageGA4() {
    this.analyticsPageGA4 = this.analyticsGA4PageService.setAnalyticsPageGA4();
  }

  setTitle() {
    this.title.setTitle(this.titlePage);
  }

  clickNext() {
    const companyCpfForm = this.spouseForm.controls.cpfSpouse.value;
    const cpfValue = companyCpfForm.replace("-", "").replace(/[^a-z\d]+/gi, "");

    if (cpfValue.length === 11 && !this.cpfSucess) {
      this.getCpf(cpfValue);
    } else if (this.selectCheckboxNoEmpty || this.cpfSucess) {
      this.cpfSucess = false;
      this.maritalStatusService.setNameSpouse(this.name.trim());
      this.maritalStatusService.setCpfSpouse(this.cpf);
      this.maritalStatusService.setForeignSpouse(
        this.selectCheckbox[0].checked
      );
      this.nextPage();
    }
  }

  analyticsEventClique() {
    const it_eventcategory = "Clique";
    const it_complementary = {
      it_eventaction: this.analyticsPage.action,
      it_eventlabel: this.analyticsPage.back,
      it_pagename: this.analyticsPage.spouse,
    };
    this.analycticsNativeService.analyticsTrackActionCommunicator(
      it_eventcategory,
      it_complementary
    );
  }

  sendTrackGA4LoadPage() {
    const paramDefautl = {
      event_name: this.analyticsPageGA4.eventNameScreenView,
      custom_path: this.analyticsPageGA4.customPathConjuge,
      implementation_team: this.analyticsPageGA4.implementationTeam,
    };

    this.analyticsGA4PageService.sendTrackGA4(paramDefautl);
  }

  getPageId(): string {
    return this.headerId;
  }

  errorMsg() {
    const control = this.spouseForm.get("nameSpouse") as FormControl;
    this.error = control.errors !== null;

    if (
      control.errors !== null &&
      control.errors.hasOwnProperty("checkShortNameMin")
    ) {
      this.textError = this.minLengthErrorText;
    }

    if (
      control.errors !== null &&
      control.errors.hasOwnProperty("checkShortNameMax")
    ) {
      this.textError = this.maxLengthErrorText;
    }

    if (
      control.errors !== null &&
      control.errors.hasOwnProperty("nameLastname")
    ) {
      this.textError = this.minLengthErrorText;
    }

    if (
      control.errors !== null &&
      control.errors.hasOwnProperty("maxNinename")
    ) {
      this.textError = this.invalidErrorText;
    }

    if (control.errors !== null && control.errors.hasOwnProperty("nameSpace")) {
      this.textError = this.invalidErrorText;
    }

    this.verifyError();
  }

  verifyCpf() {
    if (this.cpf.length === 0) {
      this.errorCpf = false;
    } else if (this.cpf.length < 14) {
      this.errorCpf = true;
      this.textErrorCpf = this.minLengthErrorCpfText;
    } else {
      this.errorCpf = false;
    }
    this.verifyError();
  }

  ionViewWillEnter() {
    this.headerFocus();
    this.setEditPageRegistratio();
    this.analyticsData();
    this.sendTrackGA4LoadPage();
  }

  ionViewDidLeave() {
    this.ariaHidden = true;
  }

  submitForm($event: any) {
    $event.preventDefault();
    return false;
  }

  setInputTextValue($event: string) {
    this.cpf = $event;

    if (this.inputTextValueNoEmpty()) {
      this.checkboxList[0].checked = false;
      this.selectCheckbox = this.checkboxList;
    }
  }

  inputTextValueNoEmpty() {
    return this.cpf.length > 0;
  }

  setSelectCheckbox($event: CheckboxModel[]) {
    this.selectCheckbox = $event;

    if (this.selectCheckboxNoEmpty()) {
      this.spouseForm.controls.cpfSpouse.setValue("");
      this.cpf = "";
      this.errorCpf = false;
    }
    this.verifyError();
  }

  selectCheckboxNoEmpty() {
    return this.selectCheckbox[0]?.checked;
  }

  verifyError() {
    const cpfValue = this.cpf.replace("-", "").replace(/[^a-z\d]+/gi, "");

    if (!this.error && !this.errorCpf && this.selectCheckboxNoEmpty()) {
      this.buttonEnable = true;
    } else if (this.error || this.errorCpf || this.cpf.length === 0) {
      this.buttonEnable = false;
    } else if (
      this.journeyService &&
      this.journeyService.registratioJourney.data.personalData !== undefined
    ) {
      const myCPF =
        this.journeyService.registratioJourney.data.personalData.cpf;
      if (myCPF === cpfValue) {
        this.errorCpf = true;
        this.textErrorCpf = this.invalidErrorCpfText;
        this.buttonEnable = false;
      } else {
        this.buttonEnable = true;
      }
    } else {
      this.buttonEnable = true;
    }
  }

  getCpf(cpfValue: string) {
    this.labelButton = "Verificando CPF...";
    this.loading = true;
    setTimeout(() => {
      this.cpfFactoryService
        .getService(this.dataOrigin)
        .getCpf(cpfValue)
        .then((data) => {
          this.loading = false;
          this.labelButton = "Verificado";
          this.cpfData = data;

          if (this.cpfData === undefined || this.cpfData === null) {
            this.buttonEnable = false;
            this.labelButton = "Continuar";
            this.errorCpf = true;
            this.cpfSucess = false;
            this.textErrorCpf = this.invalidErrorCpfText;
            this.focusInput();
          } else {
            if (this.cpfData.cpfAtivo) {
              this.errorCpf = false;
              this.labelButton = "Continuar";
              this.buttonEnable = true;
              this.insertInfConjuge();
              this.nextPage();
            } else {
              this.cpfSucess = false;
              this.errorCpf = true;
              this.buttonEnable = false;
              this.labelButton = "Continuar";
              this.textErrorCpf = this.invalidErrorIrrCpfText;
              this.focusInput();
            }
          }
        });
    }, 500);
  }

  insertInfConjuge() {
    const companyCpfForm = this.spouseForm.controls.cpfSpouse.value;
    const cpfValue = companyCpfForm.replace("-", "").replace(/[^a-z\d]+/gi, "");
    this.maritalStatusService.setNameSpouse(this.name);
    this.maritalStatusService.setCpfSpouse(cpfValue);
    this.maritalStatusService.setForeignSpouse(this.selectCheckbox[0].checked);
  }

  focusInput() {
    const input = document.getElementById("spouseCpf");

    if (input) {
      input.focus();
    }
  }

  setEditPageRegistratio() {
    if (
      this.journeyService.registratioJourney.data.maritalStatus?.spouseName?.split(
        " "
      ).length > 1
    ) {
      this.name =
        this.journeyService.registratioJourney.data.maritalStatus.spouseName;
      this.spouseForm.controls.nameSpouse.setValue(
        this.journeyService.registratioJourney.data.maritalStatus.spouseName
      );
      this.errorMsg();
    }
    if (this.journeyService.registratioJourney.data.maritalStatus?.spouseCpf) {
      const cpfValue =
        this.journeyService.registratioJourney.data.maritalStatus.spouseCpf;
      const cpfNumber = cpfValue
        .replace(/\D+/g, "")
        .replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
      this.cpf = cpfNumber;
      this.spouseForm.controls.cpfSpouse.setValue(cpfNumber);
      this.verifyCpf();
    }
    if (
      this.journeyService.registratioJourney.data.maritalStatus?.foreignSpouse
    ) {
      this.spouseText(true);
      this.errorMsg();
    }
  }

  backPage() {
    this.analyticsEventClique();
    this.back();
  }
}
